module.exports = __webpack_public_path__ + "img/landing39.ed21e865.jpg";